import React from "react";

type ContextType = {
  open: boolean,
  refresh: any
}
export default React.createContext<ContextType>({
  open: false,
  refresh: null
})